import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

/*Actions*/
import {
	getLocalUserDetails,
	// saveUserProfile,
	// getUserPendingRequests
} from '../../../redux/actions';

class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
			selectedTab: 'myProfile',
			localStorageVar: 'gessouserdetailscnet'
		}
    }

	componentWillMount() {
		const self = this,
			{ props } = self,
			{ user } = props.state;
		if(user.userDetails && user.userDetails.typeOfUser === "employee") {
			browserHistory.push("/profile/myProfile");
		} else {
			let selectedTab = props.router.location.pathname;
			selectedTab = selectedTab.split("/");
			selectedTab = selectedTab[selectedTab.length-1];
			self.setState({
				selectedTab: selectedTab
			});
			if(!selectedTab || (selectedTab !== "myProfile" && selectedTab!=="manageUsers" && selectedTab !== "userRequests")) {
				browserHistory.push("/profile/myProfile");
			} else {
				self.setState({
					selectedTab: selectedTab
				});
			};
			//Make call to get profile details if its not in store
			if(user.userDetails && user.userDetails.typeOfUser === 'customer' && !user.localUserDetails) {
				self.props.getLocalUserDetails(`userId=${user.userDetails.sso}&requestType=getLocalUser`, response => {
					if(!response.status) {
						// browserHistory.push('/error');
					}
				});
			}
			// if(!user.userProfile) {
			// 	props.getUserProfile(`userId=${user.userDetails.sso}&requestType=getUserProfile`, response => {
			// 		if(response.status) {
			// 			self.props.saveUserProfile(response);
			// 		} else {
			// 			self.setState({
			// 				errorMessage: response.responseMessage
			// 			})
			// 		}
			// 	});
			// }
			// TO DO:
			// var myVar = setInterval(function(){
			// 	if(user.selectedAccount!==""){
			// 		//Get user pending requests
			// 		dispatch(getUserPendingRequests('PendingUsersOfAccount', self.props.getUserDetails('post').ssoID, user.selectedAccount));
			// 		clearInterval(myVar);
			// 	}
			// }, 1000);
		}
	}

    render() {
		const { user } = this.props.state;
        return (
            <div>
				<h1 className="pageTitle">My Profile</h1>
				{user.userDetails &&
					(
						(user.userDetails.typeOfUser === 'customer' && user.localUserDetails && user.addressList &&
							(user.userDetails.isAdmin ? user.usersOfAccount : true)
						)
						|| user.userDetails.typeOfUser === 'employee'
					) && this.props.children && React.cloneElement(this.props.children, {...this.props})}
       		</div>
        );
    }
}
const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getLocalUserDetails: (payload, callback) => dispatch(getLocalUserDetails(payload, callback)),
	// saveUserProfile: (data) => dispatch(saveUserProfile(data)),
});

Profile = connect(mapStateToProps, mapDispatchToProps)(Profile);
export default Profile;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Profile/index.js